<template lang="pug">
  body#app(v-if="authenticated").min-h-full.flex.flex-col.text-gray-500.bg-green-100.antialiased.leading-normal.overflow-x-hidden
    .fixed.w-full.z-40.bg-green-100
      Navbar
    router-view.flex-grow
</template>

<script>
  import Navbar from './views/shared/navbar';
  import md5 from 'js-md5';

  export default {
    name: 'App',
    components: {
      Navbar,
    },
    data () {
      return {
        authenticated: false,
      };
    },
    mounted () {
      const seraphinDesignAppToken =
        this.$cookies.get('_seraphin_design_app_token') ||
        md5((prompt('Please Enter Your Password') || '').toLowerCase());

      this.authenticate(seraphinDesignAppToken);
    },
    methods: {
      authenticate (token) {
        const COOKIE_VALIDITY = 60 * 60 * 24 * 30;
        if (token == '34faa670e4e9f50029aaab057dcb2a63') {
          this.authenticated = true;
          this.$cookies.set('_seraphin_design_app_token', token, COOKIE_VALIDITY);
        } else {
          this.$cookies.remove('_seraphin_design_app_token');
        }
      },
    },
  };
</script>
